// DocumentUpload Component

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Dropzone from 'dropzone'
import _ from 'lodash'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import { stripFileName } from '../../../../shared/util/file.js'

class FormUploadMulti extends Component {
  constructor (props) {
    super(props)

    this.data = {
      files: props.files
    }

    this.state = {
      hasError: false
    }

    this.dropZone = null
    this._references = {
      refUpload: React.createRef()
    }
  }

  static get propTypes () {
    return {
      files: PropTypes.array,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      files: [],
      onChange: null
    }
  }

  componentDidMount () {
    this.initUpload()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps.files, this.props.files)) {
      this.data.files = nextProps.files
      this.setState({ dataDate: new Date() })
    }
  }

  initUpload () {
    if (this._references.refUpload.current) {
      this.dropZone = new Dropzone(
        ReactDOM.findDOMNode(this._references.refUpload.current),
        {
          paramName: 'uri',
          maxFilesize: 10,
          url: '/api/uploads',
          uploadMultiple: false,
          previewTemplate: '<div class="dz-preview"></div>',
          hiddenInputContainer: '.content',
          clickable: ['.form-uploadmulti > .content'],
          acceptedFiles: '.png,.jpg,.jpeg,.pdf,.xlsx,.csv,.zip'
        }
      )

      this.dropZone.on('error', this._onError.bind(this))
      this.dropZone.on('uploadprogress', this._onProgress.bind(this))
      this.dropZone.on('success', this._onSuccess.bind(this))
    }
  }

  componentWillUnmount () {
    if (this.dropZone) {
      this.dropZone.disable()
      this.dropZone = null
    }
  }

  render () {
    const className = `form-uploadmulti${this.state.hasError ? ' error' : ''}`
    return (
      <div className={className} ref={this._references.refUpload}>
        <div className='list'>{this._renderFiles()}</div>
        <div className='content'>
          <i className='icon icon-form-attachment' />
          {!this.state.hasError ? (
            <div className='infocont'>
              <div className='title'>
                <h2>
                  <IntlMessage ident='common.form.attachmentTitle' />
                </h2>
              </div>
              <span className='info'>
                <IntlMessage ident='common.form.attachmentInfo' />
              </span>
            </div>
          ) : (
            <div className='infocont'>
              <div className='title'>
                <h2>
                  <IntlMessage ident='common.form.attachmentTitleError' />
                </h2>
              </div>
              <span className='info'>
                <IntlMessage ident='common.form.attachmentInfoError' />
              </span>
            </div>
          )}
        </div>
      </div>
    )
  }

  isValidate () {
    if (this.state.upload) {
      return true
    }

    return false
  }

  /* Private functions */
  _renderFiles () {
    return this.data.files.map((fileObj, idx) => {
      if (!fileObj.downloadUrl) {
        const attachMentUrl = encodeURI(
          `/asset/uploads/${stripFileName(fileObj.fileName)}`
        )
        fileObj.downloadUrl = attachMentUrl
      }

      let element = 'div'
      const elementProps = {
        key: `${fileObj.fileDisplayName}-${idx}`,
        className: `item${fileObj.isDefault ? '' : ' candelete'}`,
        onClick: fileObj.onClick ? fileObj.onClick : null
      }

      if (fileObj.downloadUrl) {
        element = 'a'
        elementProps.href = fileObj.downloadUrl
        elementProps.target = '_blank'
      }

      return React.createElement(
        element,
        elementProps,
        <div className='title'>{fileObj.fileDisplayName}</div>,
        fileObj.isDefault ? null : (
          <IconButton
            type='primary'
            icon='header-upload-delete'
            canHover={false}
            className='act-avatar-delete'
            onClick={this._onDeleteFile.bind(this, fileObj)}
          />
        )
      )
    })
  }

  _onSuccess (file, message) {
    this.data.files.push({
      fileName: message.id,
      fileDisplayName: file.name,
      isDefault: false
    })

    this._onChange()
    this.setState({ hasError: false, dataDate: new Date() })
  }

  _onError (_file, _message, _e) {
    this.setState({ hasError: true, dataDate: new Date() })
  }

  _onProgress (file, progress, _e) {
    this.setState({ progressValue: progress })
  }

  _onDeleteFile (fileObj, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    _.remove(this.data.files, obj => obj.fileName === fileObj.fileName)

    this._onChange()

    this.setState({ dataDate: new Date() })
  }

  _onChange () {
    if (this.props.onChange) {
      const files = this.data.files.map(obj => {
        return {
          fileName: obj.fileName,
          fileDisplayName: obj.fileDisplayName,
          isDefault: obj.isDefault
        }
      })

      this.props.onChange(files)
    }
  }
}

export default FormUploadMulti
